module.exports = __webpack_public_path__ + "assets/88daf870bb9c47b05f5a83a11ebf32cf.png";